export default "__VITE_PUBLIC_ASSET__99a2cf47__"